import { render, staticRenderFns } from "./VendedoresForm.vue?vue&type=template&id=07d40f0a&"
import script from "./VendedoresForm.vue?vue&type=script&lang=js&"
export * from "./VendedoresForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports